import { useTranslation } from "react-i18next"
import { Role } from "../../../../../types"
import { useAppSelector } from "../../../hooks"
import Chat from "../chat/chat"
import "./announcements.css"

const PINNED_ANNOUNCEMENT = `qq群：2164010778 加群暗号（52pk）
腾讯频道【宝可梦自走棋-中文社区】：https://pd.qq.com/s/cu2d2jcha
最新的web网址推荐：
1，poke.workol.cn
2，pokev6.52kx.net
3，pokev9.52kx.net

windows客户端：
1，群文件。
2，夸克网盘https://pan.quark.cn/s/4936938ca8a5`

export function Announcements() {
  const { t } = useTranslation()
  const user = useAppSelector((state) => state.network.profile)
  const canWrite = user
    ? user.role === Role.ADMIN || user.role === Role.MODERATOR
    : false

  return (
    <div className="announcements-container hidden-scrollable">
      <div className="pinned-announcement">
        <div className="pinned-announcement-header">
          <span className="pinned-icon">📌</span>
          <span>{t("pinned_announcement")}</span>
        </div>
        <div className="pinned-announcement-content">
          {PINNED_ANNOUNCEMENT.split("\n").map((line, index) => (
            <div key={index}>{line}</div>
          ))}
        </div>
      </div>
      <Chat source="lobby" canWrite={canWrite} />
    </div>
  )
}
